export const INVOICE_DISCOUNT_LABELS = {
  DEALER_FEE_AMOUNT: 'Transactiekosten',
  DEALER_FEE: 'Transactiekosten',
  DEALER_REPLACEMENT_SERVICE_PERCENTAGE: 'Administratiekosten',
  DEALER_REPLACEMENT_EXPENSE_PERCENTAGE: 'Bijdrage coulance-/garantiefonds',
};

export const INVOICE_DISCOUNT_ORDER = [
  'SLA_REPLACEMENT_INVOICE_DISCOUNT',
  'DEALER_REPLACEMENT_SERVICE_PERCENTAGE',
  'DEALER_REPLACEMENT_EXPENSE_PERCENTAGE',
  'DEALER_FEE',
  'DEALER_FEE_AMOUNT',
];

export const INVOICE_COMPONENTS_HEADER_HEIGHT_IN_PX = 64;
export const INVOICE_COMPONENTS_FOOTER_HEIGHT_IN_PX = 51;
